import { z } from 'zod';
import { passwordSchema } from './PasswordValidationSchema';

export const ResetPasswordSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z
      .string({ required_error: 'Potwierdzenie hasła jest wymagane' })
      .min(1, 'Potwierdzenie hasła jest wymagane'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Hasła nie są identyczne',
    path: ['confirmPassword'],
  });
